import useFeaturePermissions from './useFeaturePermissions';
import { Permissions } from '@auth/permissions.ts';

/**
 * Get the permission of the entity global number ranges
 * @param organizationId
 * @returns An object containing the write and read permissions
 */
export const useGlobalNumberRangesPermissions = (organizationId: string) => {
  const { writePermission, readPermission } = useFeaturePermissions(
    organizationId,
    Permissions.GlobalNumberRangesChange,
    Permissions.GlobalNumberRangesRead
  );
  return { writePermission, readPermission };
};
